var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "modal-card", staticStyle: { width: "600px" } },
    [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [
          _vm._v("העבר קטגוריה: " + _vm._s(_vm.categoryName)),
        ]),
        _c("button", {
          staticClass: "delete",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        }),
      ]),
      _c("section", { staticClass: "modal-card-body" }, [
        _c("div", { staticClass: "move-dialog-content" }, [
          _c("p", { staticClass: "help-text" }, [
            _vm._v("בחר קטגוריה אב חדשה או העבר לשורש (ללא אב):"),
          ]),
          _c("div", { staticClass: "root-option" }, [
            _c("label", { staticClass: "radio-label" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedParentId,
                    expression: "selectedParentId",
                  },
                ],
                attrs: { type: "radio", name: "parent" },
                domProps: {
                  value: null,
                  checked: _vm._q(_vm.selectedParentId, null),
                },
                on: {
                  change: function ($event) {
                    _vm.selectedParentId = null
                  },
                },
              }),
              _c("span", { staticClass: "root-text" }, [
                _vm._v("שורש (ללא קטגוריה אב)"),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "categories-tree" }, [
            _c("div", { staticClass: "tree-section-title" }, [
              _vm._v("או בחר קטגוריה אב:"),
            ]),
            _c(
              "div",
              { staticClass: "tree-container" },
              _vm._l(_vm.availableCategories, function (category) {
                return _c("tree-node", {
                  key: category.id,
                  attrs: {
                    category: category,
                    "selected-id": _vm.selectedParentId,
                    "disabled-ids": _vm.disabledIds,
                  },
                  on: { select: _vm.selectParent },
                })
              }),
              1
            ),
          ]),
          _vm.selectedParentId
            ? _c(
                "div",
                { staticClass: "selected-info" },
                [
                  _c("b-icon", {
                    attrs: { icon: "check-circle", type: "is-success" },
                  }),
                  _c("span", [
                    _vm._v("נבחר: " + _vm._s(_vm.getSelectedCategoryName())),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _c(
        "footer",
        { staticClass: "modal-card-foot" },
        [
          _c(
            "b-button",
            {
              attrs: { type: "is-success", disabled: !_vm.canMove },
              on: { click: _vm.confirmMove },
            },
            [_vm._v("אשר")]
          ),
          _c(
            "b-button",
            {
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [_vm._v("ביטול")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }